/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import { v4 as uuid } from 'uuid';

import RichTextNotesHeader from '../RichTextNotesHeader';
import DynamicRichTextBlock from './DynamicRichTextBlock';
import CopyAssetLink from '../../../../../components/CopyAssetLink';
import { RICH_TEXT_LAYOUTS } from '../../../../../../shared/Constants';

class DynamicRichTextSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        contentValues: PropTypes.object.isRequired,
        sectionItemId: PropTypes.string,
        changeFormValue: PropTypes.func,
        convertToDynamicRichText: PropTypes.bool,
        getFormValue: PropTypes.func,
        assetLinkOptions: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool,
        isWrapUp: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.layoutOptions = [
            { value: RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_IMAGE, label: 'Top Text, Bottom Image' },
            { value: RICH_TEXT_LAYOUTS.LEFT_TEXT_RIGHT_IMAGE, label: 'Left Text, Right Image' },
            { value: RICH_TEXT_LAYOUTS.RIGHT_TEXT_LEFT_IMAGE, label: 'Right Text, Left Image' },
            { value: RICH_TEXT_LAYOUTS.TEXT_SIDE_BY_SIDE, label: 'Text Side By Side' },
            { value: RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_VIDEO, label: 'Top Text, Bottom Video' },
            { value: RICH_TEXT_LAYOUTS.TOP_TEXT_BOTTOM_AUDIO, label: 'Top Text, Bottom Audio' },
            { value: RICH_TEXT_LAYOUTS.CENTERED_TEXT, label: 'Centered Text' }
        ];

        this.state = {
            convertingToDynamicRichText: false
        };
    }

    componentDidMount() {
        const { changeFormValue, convertToDynamicRichText, memberReference, contentValues, getFormValue } = this.props;

        if (convertToDynamicRichText) {
            const existingValues = getFormValue(memberReference);
            const uuidForBlock = uuid();
            const valueToSet = {
                ...existingValues,
                content: {
                    blocks: [
                        {
                            ...contentValues,
                            id: uuidForBlock
                        }
                    ]
                },
                type: 'Dynamic Rich Text'
            };

            changeFormValue({ field: `${memberReference}`, value: valueToSet });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { changeFormValue, sectionItemId, getFormValue } = this.props;

        if (sectionItemId !== nextProps.sectionItemId) {
            if (nextProps.convertToDynamicRichText) {
                this.setState({ convertingToDynamicRichText: true });
                const uuidForBlock = uuid();

                const existingValues = getFormValue(nextProps.memberReference);
                const valueToSet = {
                    ...existingValues,
                    content: {
                        blocks: [
                            {
                                ...nextProps.contentValues,
                                id: uuidForBlock
                            }
                        ]
                    },
                    type: 'Dynamic Rich Text'
                };

                changeFormValue({ field: `${nextProps.memberReference}`, value: valueToSet });
                this.setState({ convertingToDynamicRichText: false });
            }
        }
    }

    _filterLayoutOptions = (layoutOptions) => {
        const { isWrapUp = false } = this.props;
        if (isWrapUp) {
            const topTextOnly = { value: RICH_TEXT_LAYOUTS.TOP_TEXT_ONLY, label: 'Top Text Only' };
            return [topTextOnly, ...layoutOptions.slice(3)];
        }
        return layoutOptions;
    };

    render() {
        const { memberReference, contentValues, isGlobalSectionItem } = this.props;

        if (this.state.convertingToDynamicRichText) {
            return null;
        }

        return (
            <div className={'dynamicRichTextSectionItem col-12'}>
                <FieldArray
                    name={memberReference ? `${memberReference}.content.blocks` : 'content.blocks'}
                    contentValues={contentValues}
                    layoutOptions={this._filterLayoutOptions(this.layoutOptions)}
                    component={DynamicRichTextBlock}
                    disabled={isGlobalSectionItem}
                />
                <RichTextNotesHeader />
                <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
            </div>
        );
    }
}

export default DynamicRichTextSectionItem;
